import { useTranslation } from "react-i18next";
import { Checkbox } from "../../atoms/Checkbox";
import { useTableContext } from "./TableContext";

export interface TableSelectionCellProps {
  /** Omit for the header checkbox, which toggles every row. */
  rowId?: string;
}

export const TableSelectionCell = ({ rowId }: TableSelectionCellProps) => {
  const { t } = useTranslation();
  const { selectedRowIds, headerSelection, onToggleRow, onToggleAllRows } = useTableContext();

  const checked =
    rowId === undefined
      ? headerSelection === "all"
        ? true
        : headerSelection === "some"
        ? "indeterminate"
        : false
      : selectedRowIds.has(rowId);

  return (
    <div data-slot="table-selection-cell" className="flex min-w-0 items-center justify-center overflow-hidden">
      <Checkbox
        checked={checked}
        aria-label={rowId === undefined ? t("Select all rows") : t("Select row")}
        onCheckedChange={() => (rowId === undefined ? onToggleAllRows?.() : onToggleRow?.(rowId))}
        onClick={(event) => event.stopPropagation()}
      />
    </div>
  );
};
